import {
  TitleWrapper,
  TagWrapper,
  Title,
  CompanyTagWrapper,
  TopicTagWrapper,
  TitleImgContainer,
  Img,
} from './NewsCardSmall.styles';
import { useSelector } from 'react-redux';
import FeedbackButton from '@/ui/buttons/feedbackButton/FeedbackButton';
import useFeedback from '@/hooks/useFeedback';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import SigninCTAModal from '@/ui/modals/signInCTAModal/SigninCTAModal';
import { toast } from 'sonner';

interface NewsCardSmallProps {
  article?: any;
  sx?: any;
}

const NewsCardSmall = ({ article, sx }: NewsCardSmallProps) => {
  const handleClick = () => window.open(link, '_blank');
  const language = useSelector((state: any) => state.user.language);
  const {
    image_: img,
    title: title,
    press: src,
    time: date,
    original_link: link,
    companies: companies,
    esg_topics: topics,
    count_of_cluster: cluster,
  } = article;
  const user = useSelector((state: any) => state.user.info);
  const [up, down] = useFeedback(user, article, () =>
    toast.success(t('Thank you for your feedback.')),
  );
  const [t] = useTranslation('news');
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative z-0">
      <div className="flex flex-col gap-4 p-4 rounded-md hover:bg-background-50 group">
        <TitleImgContainer>
          <TitleWrapper>
            <Title onClick={handleClick}>
              <div className="text-sm text-text-500">{title}</div>
            </Title>

            <div className="text-xs text-text-100">
              {src} | {date.slice(0, 10)} | {t('Related')} ({cluster})
            </div>
          </TitleWrapper>

          <Img src={img} alt="img" />
        </TitleImgContainer>

        <TagWrapper>
          <CompanyTagWrapper>
            {companies.map((company, i) => (
              <div className="text-xs text-text-100 bg-muted rounded px-2 py-1" key={i}>
                {company[`comp_name_${language}`]}
              </div>
            ))}
          </CompanyTagWrapper>

          <TopicTagWrapper>
            {topics.map((topic, i) => (
              <div className="text-xs text-text-100 bg-blue-50 rounded px-2 py-1" key={i}>
                {topic[`general_issue_name_${language}`]}
              </div>
            ))}
          </TopicTagWrapper>
        </TagWrapper>
        <div className="absolute bottom-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <FeedbackButton
            onClickThumbsDown={Object.keys(user).length > 0 ? down : () => setIsOpen(true)}
            onClickThumbsUp={Object.keys(user).length > 0 ? up : () => setIsOpen(true)}
          />
        </div>

        <SigninCTAModal open={isOpen} onClose={() => setIsOpen(false)} redirection="news" />
      </div>
    </div>
  );
};

export default NewsCardSmall;
